import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { FilterUtils , ObjectUtils} from 'primeng/utils';
import { BehaviorSubject, Observable, Subscription } from 'rxjs/index';
import { filter, tap } from 'rxjs/operators';
import { AdminActions } from '../../state/admin.actions';
import { AdminSelectors } from '../../state/admin.selectors';
import { SatelliteSurveillance } from './admin-satellite-surveillance.model';
import { SatelliteSurveillanceActions } from './state/satellite-surveillance.actions';
import { SatelliteSurveillanceSelectors } from './state/satellite-surveillance.selectors';
import { SatelliteSurveillanceState } from './state/satellite-surveillance.state';
import {Table} from "primeng/table";

export type SortFunctionEvent<T> = {
  data: Array<T>
  mode: string,
  field: string,
  order: number,
};

@Component({
    selector: 'admin-satellite-surveillance-component',
    templateUrl: './admin-satellite-surveillance.component.html',
    styleUrls: ['./admin-satellite-surveillance.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class AdminSatelliteSurveillanceComponent implements AfterViewInit, OnInit, OnDestroy {

    satelliteSurveillances$: Observable<SatelliteSurveillanceState>;
    availableUserStatuses$: Observable<any>;
    satellitesLoading$: Observable<boolean>;

    private userSchedulerStatusOptionsSubject = new BehaviorSubject<any>(null);
    userSchedulerStatusOptions$ = this.userSchedulerStatusOptionsSubject.asObservable();

    //    userSchedulerStatusOptions$: Observable<any>; //Observable<Array<SelectItem>>;

    satelliteNow: any;
    columns: Array<any>;

    selectLastCheckin: Array<SelectItem>;

    selectUserSchedulerStatusOptions: Array<SelectItem>;
    selectedUserSchedulerStatus: Array<string> = [];

    selectDetails: Array<SelectItem>;

    selectedSatellite: SatelliteSurveillance;

    @ViewChild(Table) pTable: Table;

    private _satelliteList: SatelliteSurveillance[] = [];
    private _subscription: Subscription = new Subscription();
    private _preventFirstChange = false;
    private _hasSorted = false;

    constructor(
        private satelliteSurveillanceSelectors: SatelliteSurveillanceSelectors,
        private adminSelectors: AdminSelectors,
        private satelliteSurveillanceActions: SatelliteSurveillanceActions,
        private adminActions: AdminActions,
        private router: Router) {

        this.satelliteSurveillances$ = this.satelliteSurveillanceSelectors.selectSatelliteSurveillances();
        this.availableUserStatuses$ = this.adminSelectors.selectAvailableUserStatuses();
        this.satellitesLoading$ = this.satelliteSurveillanceSelectors.selectLoadingStatus();

        FilterUtils['account-contains'] = (value, customFilter): boolean => {
            if (customFilter === undefined || customFilter === null || customFilter.trim() === '') {
                return true;
            }

            if (value === undefined || value === null) {
                return true;
            }

            return value.toString()
                .toLowerCase()
                .indexOf(customFilter.toLowerCase()) > -1;
        };

        // TODO: check if we can handle in from FE
        FilterUtils['lastCheckin-equals'] = (value, customFilter): boolean => {
            if (customFilter === undefined || customFilter === null || customFilter.trim() === 'all') {
                return true;
            }

            if (value === undefined || value === null) {
                return true;
            }

            if (customFilter === '!24') {
                if (this.satelliteNow - 24 * 60 * 60 * 1000 < value) {
                    return false;
                }
            }
            if (customFilter === '24') {
                if (this.satelliteNow - 24 * 60 * 60 * 1000 > value) {
                    return false;
                }
            }

            return true;
        };

        FilterUtils['customFilter'] = (value, customFilter): boolean =>
            true;
    }

    // https://github.com/primefaces/primeng/blob/master/src/app/showcase/components/table/tablefilterdemo.ts

    ngOnInit(): void {
        this.selectLastCheckin = [
            {label: '--All--', value: 'all'},
            {label: 'Checked in last 24 hours', value: '24'},
            {label: 'Not checked in last 24 hours', value: '!24'}
        ];

        this.selectUserSchedulerStatusOptions = [
            {label: 'Scheduler: all', value: 'all'},
            {label: 'Scheduler: active', value: 'active'},
//            {label: 'Scheduler: ar3active', value: 'ar3active'},
//            {label: 'Scheduler: ar3beta', value: 'ar3beta'},
            {label: 'Scheduler: pause', value: 'pause'}
        ];

        this.selectDetails = [
            {label: 'Hide satellites without data sources', value: 'hideSatellitesWithoutDataSources'},
            {label: 'Hide satellites without checkins', value: 'hideSatellitesWithoutCheckins'}
        ];

        this.columns = [
            {field: 'autoremindAccount', header: 'Account', filterMatchMode: 'account-contains', width: 160},
            {field: 'lastCheckinLogEvent', header: 'Installed On', width: 140},
            {field: 'moduleType', header: 'Type', width: 140},
            {field: 'lastCheckin', header: 'Last Checkin (UTC)', filterMatchMode: 'lastCheckin-equals', width: 150},
            {field: 'userStatus', header: 'User/Scheduler Status', width: 160},
            {field: 'satelliteVersion', header: 'Satellite Version', width: 150},
            {field: 'totalDatasourcesCount', header: 'Details'} // No width makes this flexible based on content
        ];
    }

  ngAfterViewInit(): void {
        // TODO: cleanup subscriptions or refactor to let frontend subscribe
        this._subscription.add(
            this.satellitesLoading$
                .pipe(
                    tap(loading => console.log('satellites surveillance loading....   ' , loading)),
                    filter(loading => loading === true)
                )
                .subscribe(() => {
                    this.satelliteSurveillanceActions.getSatelliteSurveillance(undefined);
                    this.adminActions.getAvailableUserStatuses(undefined);
                })
        );
        // TODO: Combine into new stream getting formState and settings when user ready - to avoid subscriptions

        // TODO:  this is done for filter. Check if we can handle it from FE
        this._subscription.add(
            this.satelliteSurveillances$
                .subscribe(satelliteNu => {
                    this._satelliteList = satelliteNu.satelliteSurveillance;
                    this.satelliteNow = satelliteNu.satelliteNow;
                })
        );

        this.userSchedulerStatusOptionsSubject.next(this.selectUserSchedulerStatusOptions);

        this._subscription.add(
            this.availableUserStatuses$
                .subscribe(states => {
                    // TODO: Refactor view to just subscribe to the state! Or merge the data in the pipe to still avoid subscriptions here
                    if (states.length > 0) {
                        this.selectUserSchedulerStatusOptions.push({label: 'User: all', value: 'allUser'});
                        states.forEach(status => {
                            const item = {
                                label: `User: ${status.userStatus}`,
                                value: status.userStatus
                            };
                            this.selectUserSchedulerStatusOptions.push(item);
                        });
                    }

                    this.userSchedulerStatusOptionsSubject.next(this.selectUserSchedulerStatusOptions);
                })
        );

    }

    ngOnDestroy() {
      this._subscription.unsubscribe();
      this.pTable.clearCache();
      this.pTable.ngOnDestroy();
    }

  setRoute(route: string, param: string, paramValue: string): void {

        this.router.navigate([route], {queryParams: {[param]: paramValue}});
    }

    displayLastCheckinWithPrefix(satellite): string {
        let prefix = '';
        prefix = satellite.typeOfCheck === 'unresponsive' ? 'Away: ' : 'Next: ';

        const dayHourMin = this.convertToDayHourMinutes(satellite.howLongAgoLastCheckIn);

        return `${prefix} ${dayHourMin}`;

    }

    convertToDayHourMinutes(timeinseconds): string {

        const days = Math.floor(timeinseconds / 60 / 60 / 24);
        let secondsLeft = timeinseconds - (days * 60 * 60 * 24);
        const hours = Math.floor(secondsLeft / 60 / 60);
        secondsLeft = secondsLeft - (hours * 60 * 60);
        const minutes = Math.floor(secondsLeft / 60);

        return `${days}d ${hours}h ${minutes}m`;
    }

    // Called when toggling a single option in the filter - either schedulerState or userStatus
    statusFilter(event, satelliteTable): boolean {
        //const schedulerStatus = ['active', 'pause'];
        const schedulerStatuses = ['active', 'ar3active', 'ar3beta', 'pause'];
        debugger;

//        this.selectedUserSchedulerStatus = this.selectedUserSchedulerStatus.filter(status =>
//            !status.includes('ar3active') && !status.includes('ar3beta'));

        if (event.itemValue === 'all') {
            const alreadySelected = this.selectedUserSchedulerStatus.filter(status => schedulerStatuses.includes(status));

            alreadySelected.forEach(selectedStatus => {
                this.selectedUserSchedulerStatus.splice(this.selectedUserSchedulerStatus.indexOf(selectedStatus), 1);
            });

            if (this.selectedUserSchedulerStatus.includes('all')) {
                this.selectedUserSchedulerStatus.push('active');
                this.selectedUserSchedulerStatus.push('ar3active');
                this.selectedUserSchedulerStatus.push('ar3beta');
                this.selectedUserSchedulerStatus.push('pause');
            }
        }

        if (schedulerStatuses.indexOf(event.itemValue) > -1 || event.itemValue === 'all') {
            if (event.itemValue === 'active') {
                this.selectedUserSchedulerStatus.push('ar3active');
                this.selectedUserSchedulerStatus.push('ar3beta');
            }

            const selectedSchedulers = this.selectedUserSchedulerStatus.filter(val => schedulerStatuses.includes(val));

            return satelliteTable.filter(selectedSchedulers, 'schedulerState', 'in');
        }

        return this.userStatusFilter(event, satelliteTable, schedulerStatuses);
    }


    userStatusFilter(event, satelliteTable, schedulerStatuses): any {
        if (event.itemValue === 'allUser') {

            const alreadySelected = this.selectedUserSchedulerStatus.filter(status => !schedulerStatuses.includes(status));

            alreadySelected.forEach(selectedStatus => {
                if (selectedStatus !== 'allUser' && selectedStatus !== 'all') {
                    this.selectedUserSchedulerStatus.splice(this.selectedUserSchedulerStatus.indexOf(selectedStatus), 1);
                }
            });

            if (this.selectedUserSchedulerStatus.includes('allUser')) {

                const availableUserStatuses = this.selectUserSchedulerStatusOptions.filter(
                    userStatus => !schedulerStatuses.includes(userStatus.value));

                availableUserStatuses.forEach(userStatuses => {
                    if (userStatuses.value !== 'allUser' && userStatuses.value !== 'all') {
                        this.selectedUserSchedulerStatus.push(userStatuses.value);
                    }
                });
            }
        }

        // Remove any scheduler states so the table filter only applies to userStatus
        var userStatusOnly = this.selectedUserSchedulerStatus.filter(status =>
            !schedulerStatuses.includes(status) && status !== 'all');

        return satelliteTable.filter(userStatusOnly, 'userStatus', 'in');
    }

    detailsFilter(event, satelliteTable): boolean {

        if (event === undefined || event === null || event.length === 0) {
            return satelliteTable.filter(event, 'totalDatasourcesCount', 'customFilter');
        }

        event.find(selected => {
            if ('hideSatellitesWithoutDataSources'.indexOf(selected) > -1) {
                return satelliteTable.filter(0, 'totalDatasourcesCount', 'gt');
            }
        });

        event.find(selected => {
            if ('hideSatellitesWithoutCheckins'.indexOf(selected) > -1) {
                return satelliteTable.filter(undefined, 'lastCheckin', 'notEquals');
            }
        });

        return true;
    }

    onRowSelect(event: any): void {
        this.satelliteSurveillanceActions.getSatelliteOtherDetails(event.data);
    }

    getSatellites(event): void {
        this.satelliteSurveillanceActions.getSatelliteSurveillance(undefined);
    }

    public typeOfCheckToolTip(satellite): string {
        return satellite.typeOfCheck && satellite.typeOfCheck === 'unresponsive' ?
            'This is how long ago it was since the satellite checked in (it did not check in after the checkinInterval passed)' :
            'This is when the next checkin is expected (according to the checkinInterval)';
    }

    satelliteTrackBy(index, item) {
        return item.satelliteId;
    }

    onFilterApply(event):void {
      if(this._hasSorted){
        this._hasSorted = false;
        this._preventFirstChange = true;
      }
      this.pTable._value = event.filteredValue;
    }

    firstChange(num):void {
      if(this._preventFirstChange){
        this._preventFirstChange = false;
        return;
      }
      this.pTable._value = this._satelliteList;
    }

    applySort(event: SortFunctionEvent<SatelliteSurveillance>):void {
      this._hasSorted = true;
      const copySatelliteList = this._satelliteList.slice();

      copySatelliteList.sort((data1, data2) => {
        let value1 = ObjectUtils.resolveFieldData(data1, event.field);
        let value2 = ObjectUtils.resolveFieldData(data2, event.field);
        let result = null;

        if (value1 == null && value2 != null)
          result = -1;
        else if (value1 != null && value2 == null)
          result = 1;
        else if (value1 == null && value2 == null)
          result = 0;
        else if (typeof value1 === 'string' && typeof value2 === 'string')
          result = value1.localeCompare(value2);
        else
          result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

        return (event.order * result);
      });

      this._satelliteList = copySatelliteList;
      this.pTable._value = this._satelliteList;
    }
}
